'use client';

import AdvantagesList, { AdvantagesListProps } from '../components/blog/AdvantagesList';

// Компонент-обертка для AdvantagesList, который будет использоваться в MDX
export default function MDXAdvantagesList(props: AdvantagesListProps) {
  return <AdvantagesList {...props} />;
} 